import flag from "../../assets/svgs/flag.svg";
import {
  Box,
  createTheme,
  FilledInput,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  ThemeProvider,
} from "@mui/material";

const customTheme = createTheme({
  palette: {
    primary: {
      main: "#000000",
    },
    secondary: {
      main: "#007BC0",
    },
  },
});

interface FormBasicInfoSelectProps {
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  label?: string;
  ariaLabel?: string;
  placeholder?: string;
  options: { value: string; label: string }[];
}

const FormBasicInfoSelect = ({
  value,
  onChange,
  label,
  ariaLabel,
  placeholder,
  options,
}: FormBasicInfoSelectProps) => {
  return (
    <ThemeProvider theme={customTheme}>
      <FormControl variant="filled" focused>
        {label && (
          <InputLabel shrink={!!value} sx={{ fontWeight: 500, fontSize: 20 }}>
            {label}
          </InputLabel>
        )}

        <Box sx={{ position: "relative", cursor: "pointer" }}>
          <img
            style={{
              width: "12px",
              height: "12px",
              marginTop: "25px",
              cursor: "pointer",
              position: "relative",
              left: "288px",
              color: customTheme.palette.primary.main,
            }}
            src={flag}
            alt="flag"
          />
        </Box>

        <Select
          value={value}
          onChange={onChange}
          displayEmpty
          input={<FilledInput />}
          inputProps={ariaLabel ? { "aria-label": ariaLabel } : undefined}
          sx={{
            backgroundColor: "#E0E2E5",
            fontSize: "17px",
            "& .MuiSelect-select": {
              color: value ? "#000" : "#7D8389",
            },
            "& .MuiSelect-icon": {
              display: "none",
            },
          }}
        >
          {placeholder && !value && (
            <MenuItem
              value=""
              disabled
              sx={{ height: "50px", display: "flex", alignItems: "center" }}
            >
              <Box
                sx={{
                  position: "absolute",
                  left: "16px",
                  top: "50%",
                  transform: "translateY(-40%)",
                  color: "#989898",
                  pointerEvents: "none",
                }}
              >
                {placeholder}
              </Box>
            </MenuItem>
          )}

          {options.map((option) => (
            <MenuItem
              key={option.value}
              value={option.value}
              sx={{
                height: "50px",
                borderRadius: 0,
                fontWeight: 500,
                "&:hover": {
                  backgroundColor: customTheme.palette.secondary.main,
                  color: "#fff",
                  fontWeight: 500,
                },
              }}
            >
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </ThemeProvider>
  );
};

export default FormBasicInfoSelect;
